import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import WidgetCard from './WidgetCard'

const Pack = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  & + & { border-top: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'}; padding-top: 16px; margin-top: 8px; }
`

const Ring = styled.div`
  --pct: ${(p) => p.$pct}%;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  flex-shrink: 0;
  background: conic-gradient(
    ${(p) => p.theme?.color?.accent || '#6B9080'} var(--pct),
    ${(p) => p.theme?.color?.bgSubtle || '#F4F0E9'} var(--pct)
  );
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    inset: 6px;
    background: ${(p) => p.theme?.color?.bgRaised || '#fff'};
    border-radius: 50%;
  }
`

const RingText = styled.span`
  position: relative;
  z-index: 1;
  font-size: 13px;
  font-weight: 700;
  color: ${(p) => p.theme?.color?.ink || '#1F2937'};
`

const Body = styled.div`
  flex: 1;
  min-width: 0;
`

const Name = styled.div`
  font-weight: 600;
  color: ${(p) => p.theme?.color?.ink || '#1F2937'};
`

const Sub = styled.div`
  font-size: 13px;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
`

export default function PackProgressCard({ data }) {
  const navigate = useNavigate()
  if (!data || data.length === 0) return null
  return (
    <WidgetCard title="Your packs">
      {data.map((p) => {
        const pct = p.sessionsTotal > 0 ? Math.round((p.sessionsUsed / p.sessionsTotal) * 100) : 0
        return (
          <Pack key={p.packId} onClick={() => navigate('/patient-home/shop/packs')} style={{ cursor: 'pointer' }}>
            <Ring $pct={pct}>
              <RingText>{p.sessionsUsed}/{p.sessionsTotal}</RingText>
            </Ring>
            <Body>
              <Name>{p.practitionerName}</Name>
              <Sub>{p.expiryLabel}</Sub>
            </Body>
          </Pack>
        )
      })}
    </WidgetCard>
  )
}
